import React, { Component } from 'react';
// logo
import Logo, { LogoSize } from '../../brand/Logo';
// css
import './Banner.css';

class Banner extends Component {
  render() {
    return (
      <div className="Banner-container">
        <div className="Banner-header">
          <Logo size={LogoSize.large} />
        </div>
        <div className="Banner-body">
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default Banner;


// WEBPACK FOOTER //
// ./src/pages/Page/Banner.js